Object.defineProperty(exports, '__esModule', {
  value: true
});

var React = require('react');

function _interopNamespace(e) {
  if (e && e.__esModule) return e;
  var n = Object.create(null);

  if (e) {
    Object.keys(e).forEach(function (k) {
      if (k !== 'default') {
        var d = Object.getOwnPropertyDescriptor(e, k);
        Object.defineProperty(n, k, d.get ? d : {
          enumerable: true,
          get: function get() {
            return e[k];
          }
        });
      }
    });
  }

  n["default"] = e;
  return Object.freeze(n);
}

var React__namespace = /*#__PURE__*/_interopNamespace(React);
/**
 *
 * @param init -> initial state
 * @param reducer -> reducer function
 * @param {StoreOptions}
 * @returns -> [StoreProvider -> wrap it to access the hooks [store, dispatch], useStore -> access the store, useDispatch -> dispath actions]
 */


var createStore = function createStore(init, reducer, _a) {
  var _b = _a === void 0 ? {} : _a,
      _c = _b.useStoreName,
      useStoreName = _c === void 0 ? 'useStore' : _c,
      _d = _b.useDispatchName,
      useDispatchName = _d === void 0 ? 'useDispatch' : _d,
      _e = _b.providerName,
      providerName = _e === void 0 ? 'Provider' : _e;

  var StoreContext = React__namespace.createContext(null);
  var StoreDispatchContext = React__namespace.createContext(null);
  StoreContext.displayName = providerName;
  StoreDispatchContext.displayName = providerName + "Dispatch";
  /**
   *
   * @param props -> compose children
   * @returns -> StoreProvider -> generic context
   */

  var StoreProvider = function StoreProvider(props) {
    var children = props.children;

    var _a = React__namespace.useReducer(reducer, init),
        state = _a[0],
        dispatch = _a[1];

    return React__namespace.createElement(StoreContext.Provider, {
      value: state
    }, React__namespace.createElement(StoreDispatchContext.Provider, {
      value: dispatch
    }, children));
  };
  /**
   *
   * @returns -> store
   */


  var useStore = function useStore() {
    var store = React__namespace.useContext(StoreContext);

    if (!store) {
      throw new Error(useStoreName + " must be consumed (used) within a " + providerName);
    }

    return store;
  };
  /**
   *
   * @returns -> dispatch (fn) -> action
   */


  var useDispatch = function useDispatch() {
    var dispatch = React__namespace.useContext(StoreDispatchContext);

    if (!dispatch) {
      throw new Error(useDispatchName + " must be consumed (used) within a " + providerName);
    }

    return dispatch;
  };

  return [StoreProvider, useStore, useDispatch];
};

exports.createStore = createStore;